var FinanceDrawerEnum = /* @__PURE__ */ ((FinanceDrawerEnum2) => {
  FinanceDrawerEnum2["Credit"] = "credit";
  FinanceDrawerEnum2["TradeIn"] = "trade-in";
  FinanceDrawerEnum2["Insurance"] = "insurance";
  return FinanceDrawerEnum2;
})(FinanceDrawerEnum || {});
export {
  FinanceDrawerEnum
};
